import React from 'react'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { Security } from '@okta/okta-react'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'
import { Provider } from 'react-redux'
import { IntlProvider } from 'react-intl'
import { CustomProvider } from 'rsuite'
import frFR from 'rsuite/locales/fr_FR'
import enUS from 'rsuite/locales/en_US'
import esES from 'rsuite/locales/es_ES'
import { ConfigProvider } from './contexts/ConfigContext'
import './index.scss'
import App from './App'
import reportWebVitals from './reportWebVitals'
import store from './store'
import i18n from './i18n'
import {
  msalConfig,
  oktaConfig,
  msalConfigBo,
} from './views/auth/signin/authConfig'

import { getLocalStorage } from './utils/localStorage'

const msalInstanceClient = new PublicClientApplication(msalConfig)
const msalInstanceBo = new PublicClientApplication(msalConfigBo)

function MsalProviderWrapper({ children }) {
  // Déterminez quelle instance utiliser basée sur la route actuelle
  const msalInstance = window.location.pathname?.includes('/bo')
    ? msalInstanceBo
    : msalInstanceClient

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>
}

const oktaAuth = new OktaAuth({
  issuer: oktaConfig.issuer,
  clientId: oktaConfig.clientId,
  redirectUri: oktaConfig.redirectUri,
  scopes: oktaConfig.scopes,
})

const lng = getLocalStorage('LANGUAGE')

const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  window.location.replace(
    toRelativeUrl(originalUri || '/', window.location.origin)
  )
}

const container = document.getElementById('root')
const root = createRoot(container)

root.render(
  <BrowserRouter>
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      <MsalProviderWrapper>
        <Provider store={store}>
          <ConfigProvider>
            <IntlProvider locale={i18n.language}>
              <CustomProvider
                locale={lng === 'es' ? esES : lng === 'en' ? enUS : frFR}
              >
                <App />
              </CustomProvider>
            </IntlProvider>
          </ConfigProvider>
        </Provider>
      </MsalProviderWrapper>
    </Security>
  </BrowserRouter>
)

reportWebVitals()

